import { ApiModel, FoodSocial, IFoodSocial } from "@models/FoodSocial";
import http from '../fetch';
import { ID } from "@datassential/platform-ui-lib";
import { useData } from "@hooks/useData";

async function getSocial (wordId: ID): Promise<IFoodSocial> {
    const response: ApiModel = await http.get('get food profile social', { keywordId: wordId });
    try {
        return new FoodSocial({ apiModel: response });
    } catch (err) {
        console.error(err);

        return {
            ...new FoodSocial(),
            hasData: false,
        };
    }
}

export function useFoodSocial(wordId: ID) {
    return useData(new FoodSocial(), getSocial, wordId);
}